<template>
  <!-- new detail -->
  <div class="nrbf">
    <div class="maxsize n-box">
      <div class="row">
        <div class="news-nr-box">
          <h3 style="font-size: 22px;; text-align:center; padding:20px;">{{ detailObj.title }}</h3>
          <div style="font-size:14px; line-height:35px;" v-html="detailObj.content"></div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

  </div>

</template>

<script>
import * as newApi from "@/components/oh/newsApi";

export default {
  name: 'NewsDetail',
  components: {
  },
  data() {
    return {
      detailObj: {}
    }
  },
  props: ['id'],
  created() {
    this.detailObj = newApi.getNewsDetailById(this.id) || {}
  },
  methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.row {
  margin: 0
}
</style>
